module.exports = __webpack_public_path__ + "img/10.b7b80245.png";